<template>
  <hm-content>
    <div class="table-panel flex flex-end">
      <div>
        <el-input
          clearable
          style="width:200px"
          v-model.trim="searchCondition.oldMobile"
          placeholder="原会员手机号"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-input
          clearable
          style="width:200px"
          v-model.trim="searchCondition.mobile"
          placeholder="新会员手机号"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-date-picker
          clearable
          :default-time="['00:00:00', '23:59:59']"
          v-model="searchCondition.operatorTimeArry"
          type="datetimerange"
          align="right"
          start-placeholder="操作开始时间"
          end-placeholder="操作结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="small"
          class="mr10"
        ></el-date-picker>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button type="info" size="small" @click="reset">重置</el-button>
      </div>
    </div>
    <div class="table">
      <el-table
        :data="plusRightMoveList.records"
        style="width: 100%"
        stripe
        size="small"
        border
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="原会员手机号"
          prop="oldMobile"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="mobile"
          label="新会员手机号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="operatorTime"
          label="操作时间"
          width="180"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="operatorName"
          label="操作人"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="remark"
          label="备注"
          min-width="280"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="plusRightMoveList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
        :page-size="pageSize"
      ></el-pagination>
    </div>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      searchCondition: {
        operatorTimeArry: [
          moment().startOf("month").format("YYYY-MM-DD HH:mm:ss"),
          moment().endOf("month").format("YYYY-MM-DD HH:mm:ss")
        ]
      },
      currentPage: 1,
      pageSize: 10
    };
  },
  computed: mapGetters(["plusRightMoveList"]),
  mounted() {
    this.queryList();
  },
  methods: {
    queryList() {
      const params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.operatorStartTime =
        this.searchCondition.operatorTimeArry &&
        this.searchCondition.operatorTimeArry.length > 0
          ? this.searchCondition.operatorTimeArry[0]
          : null;
      searchCondition.operatorEndTime =
        this.searchCondition.operatorTimeArry &&
        this.searchCondition.operatorTimeArry.length > 0
          ? this.searchCondition.operatorTimeArry[1]
          : null;
      delete searchCondition.operatorTimeArry;
      Object.assign(params, searchCondition);
      this.$store.dispatch("queryPlusRightMoveList", params);
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    reset() {
      this.searchCondition = {
        operatorTimeArry: [
          moment().startOf("month").format("YYYY-MM-DD HH:mm:ss"),
          moment().endOf("month").format("YYYY-MM-DD HH:mm:ss")
        ]
      };
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    }
  }
};
</script>